module.exports = __webpack_public_path__ + "img/9788901081885.1cb939d8.jpg";